// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Forms-rows {
    display: flex;
    gap: 20px;
}

@media screen and (max-width: 1024px) {

    .Forms-rows {
        flex-direction: column;
    }
}

.b5-body-500 .ant-form-item .ant-form-item-label >label, .b5-body-500 .ant-form-item-control-input .ant-form-item-control-input-content >label {
    color: #727272 !important;
}

.Forms-rows .ant-input-outlined {
    background-color: #F8F8F8 !important;
    height: 56px;
    padding: 20px 30px;
    border-radius: 20px;
    border: none !important;
}

.Forms-textarea-full .ant-input-outlined {
    background-color: #F8F8F8 !important;
    height: 97px;
    padding: 20px 30px;
    border-radius: 20px;
    border: none !important;
}

.Forms-rows .ant-form-item-required::before {
    display: none !important;
}

.Form-Button .button-yellow-md {
    width: 100%;
    border: none !important;
}
input::placeholder {
    color: #BFBFBF !important;
    font-weight: 500px;
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: 14px;
}
.form-select {
    height: 52px;
}
.form-select > .ant-select-selector {
    background: #F8F8F8 !important;
    border-radius: 20px !important;
}

.ant-form-item-row, .ant-form-item-label, .ant-input-outlined, .ant-select-selection-placeholder{
    font-family: Poppins !important;
}`, "",{"version":3,"sources":["webpack://./src/css/Forms.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oDAAoD;IACpD,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":[".Forms-rows {\n    display: flex;\n    gap: 20px;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .Forms-rows {\n        flex-direction: column;\n    }\n}\n\n.b5-body-500 .ant-form-item .ant-form-item-label >label, .b5-body-500 .ant-form-item-control-input .ant-form-item-control-input-content >label {\n    color: #727272 !important;\n}\n\n.Forms-rows .ant-input-outlined {\n    background-color: #F8F8F8 !important;\n    height: 56px;\n    padding: 20px 30px;\n    border-radius: 20px;\n    border: none !important;\n}\n\n.Forms-textarea-full .ant-input-outlined {\n    background-color: #F8F8F8 !important;\n    height: 97px;\n    padding: 20px 30px;\n    border-radius: 20px;\n    border: none !important;\n}\n\n.Forms-rows .ant-form-item-required::before {\n    display: none !important;\n}\n\n.Form-Button .button-yellow-md {\n    width: 100%;\n    border: none !important;\n}\ninput::placeholder {\n    color: #BFBFBF !important;\n    font-weight: 500px;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: 14px;\n}\n.form-select {\n    height: 52px;\n}\n.form-select > .ant-select-selector {\n    background: #F8F8F8 !important;\n    border-radius: 20px !important;\n}\n\n.ant-form-item-row, .ant-form-item-label, .ant-input-outlined, .ant-select-selection-placeholder{\n    font-family: Poppins !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
